import React from 'react'
import card1 from '../../assets/aboutUs/8_About us.png'
import card2 from '../../assets/aboutUs/9_About us.png'
import card3 from '../../assets/aboutUs/10_About us.png'
import card4 from '../../assets/aboutUs/11_About us.png'
import card5 from '../../assets/aboutUs/12_About us.png'
import card6 from '../../assets/aboutUs/13_About us.png'
import card7 from '../../assets/aboutUs/14_About us.png'
import card8 from '../../assets/aboutUs/15_About us.png'

const UniqueSP = () => {

  const cards = [
    {
      title: "Innovative Technology Integration",
      content: "We seamlessly blend the latest technology with creative storytelling to create immersive and unforgettable event experiences. Our use of cutting-edge tech ensures that our events are not only memorable but also ahead of industry trends.",
      image: card1
    },
    {
      title: "Excellence in Every Detail",
      content: "Quality is our hallmark. From the initial planning stages to the final execution, we maintain a relentless focus on excellence, ensuring that every aspect of the event is flawlessly executed and exceeds client expectations.",
      image: card2
    },
    {
      title: "Passionate and Diverse Team",
      content: "Our team comprises passionate professionals from various backgrounds, including visionary creatives, meticulous planners, and tech-savvy experts. This diversity allows us to bring a wealth of perspectives and skills to each project, resulting in truly unique and innovative events.",
      image: card3
    },
    {
      title: "Sustainable Practices",
      content: "We are committed to responsible event management. Our dedication to sustainability means we actively strive to minimize our environmental impact and promote eco-friendly practices in all our events.",
      image: card4
    },
    {
      title: "Customized Client Experience",
      content: "We pride ourselves on our client-centric approach. We take the time to understand each client's unique needs and vision, tailoring our services to provide personalized and exceptional experiences that leave a lasting impression",
      image: card5
    },
    {
      title: "Integrity and Transparency",
      content: "Trust is at the foundation of our business. We conduct all our operations with honesty and transparency, building strong, trustworthy relationships with our clients, partners, and team members.",
      image: card6
    },
    {
      title: "Creative Boldness",
      content: "Our approach to event management is driven by bold, creative thinking. We push boundaries and embrace innovative ideas, ensuring that every event we produce stands out and leaves a memorable impact on attendees.",
      image: card7
    },
    {
      title: "Comprehensive Event Solutions",
      content: "From grand galas and corporate conferences to intimate gatherings and product launches, we offer a full spectrum of event management services. Our comprehensive solutions cover every aspect of event planning and execution, making us a one-stop-shop for all your event needs.",
      image: card8
    },
  ]

  return (
    <div className='h-fit w-full bg-blue-bg bg-cover bg-center  flex flex-col items-center py-24 text-[#fff]'>
        
        <h1  data-aos="fade-up"  className='text-4xl  font-mosk600'>Unique Selling Points</h1>

        <div className='flex flex-col px-6 md:px-12 lg:px-36 py-16 gap-20 lg:gap-24' >
          {
            cards.map((card, index)=>{
              if(index % 2 === 1){
                return(
                  <div key={index} className='flex flex-col-reverse md:flex-row items-center justify-center gap-4' >
                    <div className='w-full md:w-[60%] flex flex-col gap-3 ' >
                      <h1  data-aos="fade-right" data-aos-duration="800" className='text-4xl font-mosk600' >{card.title}</h1>
                      <p  data-aos="fade-right" data-aos-duration="950" className='font-light text-lg lg:text-xl' >{card.content}</p>
                    </div>
                    <div className='w-full md:w-[40%] flex justify-center '>
                        <img  data-aos="fade-left"  className='h-[25vh] md:h-[20vh] lg:h-[30vh]' src={card.image} alt="" />
                    </div>
                  </div>
                )
              }else{
                return(
                  <div key={index} className='flex flex-col md:flex-row items-center  justify-center gap-4' >
                    <div  className='w-full md:w-[40%] flex justify-center '>
                        <img  data-aos="fade-right"  className='h-[25vh] md:h-[20vh] lg:h-[30vh]' src={card.image} alt="" />
                    </div>
                    <div className='w-full md:w-[60%] flex flex-col gap-3 ' >
                      <h1  data-aos="fade-left" data-aos-duration="800" className='text-4xl font-mosk600' >{card.title}</h1>
                      <p  data-aos="fade-left" data-aos-duration="950" className='font-light text-lg lg:text-xl' >{card.content}</p>
                    </div>
                  </div>
                )
              }
            })
          }
      </div>
      <div className='w-[90%] md:w-[75%] lg:w-[60%]' >
        <p className='text-center text-xl lg:text-2xl font-mosk600' >By choosing Blue Door Event Solutions, clients gain a partner dedicated to creating extraordinary events that captivate the senses, inspire the mind, and leave lasting memories.</p>
      </div>
    </div>
  )
}

export default UniqueSP
